import React from 'react';
import styled from 'styled-components';
import BradyCutout from '../../../assets/brady-cutout.png';
import { ContentContainer, H8, P4 } from '../../../components/GlobalStyles';
import { media } from '../../../components/style-utils';
import { H1, H3, H4 } from '../../../components/Typography/Typography';

export const SectionHeyThere = function() {
  return (
    <Container>
      <IntroContentContainer>
        <IntroBox>
          <Label>NEW</Label>
          <Heading>
            Introducing...
            <br />
            The 167
          </Heading>
          <Byline>A hands-on, 12-week social media mentorship</Byline>
        </IntroBox>
      </IntroContentContainer>

      <BradySection>
        <BradyContentContainer>
          <CardWrapper>
            <AboutCard>
              <CardHeading as="div" fontWeight="Black">
                Well hey there!
              </CardHeading>
              <CardText as="div">
                <p>
                  <b>I’m Brady Shearer - creator of Pro Church Tools and Nucleus</b> - and your lead instructor
                  throughout the The 167 mentorship program.
                </p>
                <p>For years, I’ve watched firsthand what it looks like when churches truly embrace social media.</p>
                <p>
                  <b>The result?</b> An explosion of new visitors. Increased giving. A highly engaged congregation
                  active in volunteering, small groups, and community outreach. Young people getting involved!
                </p>
                <p>
                  If this isn’t your church’s current reality - that just means we have untapped potential to unlock.
                </p>
                <p>
                  <b>That’s what The 167 mentorship is for - here’s how it works...</b>
                </p>
              </CardText>
              <BradyProfileImage>
                <img src={BradyCutout} alt="Brady Shearer" />
              </BradyProfileImage>
            </AboutCard>
          </CardWrapper>
        </BradyContentContainer>
      </BradySection>
    </Container>
  );
};

const Container = styled.section`
  max-width: 100vw;
  overflow: hidden;
  padding-top: 10rem;

  ${media.tabletPortraitAndUp`
    padding-top: 7rem;
  `}
`;

const IntroBox = styled.div`
  max-width: 90rem;
  margin-left: auto;
  margin-right: auto;

  padding-left: 4rem;
  /* padding-right: 2.5rem; */
`;

const IntroContentContainer = styled(ContentContainer)``;

const Byline = styled(H3)`
  font-weight: 900;
  font-size: 3rem;
  color: #767676;

  max-width: 35rem;
`;

const Label = styled(H4)`
  display: inline-block;
  margin: 0;
  padding: 0.5em 1em;

  font-size: 2rem;

  background-color: var(--colorPrimaryMedium);
  color: var(--colorWhite);
  border-radius: 1rem;
`;

const Heading = styled(H1)`
  margin: 0.5rem 0 0;
`;

// Styled Brady
const BradySection = styled.section`
  padding: 4rem 0 2rem;
  position: relative;
  z-index: 1;
`;

const BradyContentContainer = styled(ContentContainer)`
  text-align: center;
`;

const CardWrapper = styled.div`
  position: relative;
  max-width: 60rem;
  margin: 0 auto;

  ${media.tabletLandscapeAndUp`
    max-width: 75rem;
  `};

  ${media.desktopAndUp`
    max-width: 90rem;
  `};
  /* margin-bottom: 20rem; */
`;

const AboutCard = styled.div`
  background-color: var(--colorPrimaryLight);
  /* box-shadow: 0 0.2rem 4.6rem 0 rgba(29, 98, 115, 0.15); */
  border-radius: 3.5rem;
  border: 1px solid transparent; // prevent collapsing
  position: relative;
  z-index: 2;
  text-align: left;
  padding: 8rem 6rem;
  overflow: hidden;

  ${media.phoneOnly`
    margin-left: -2rem;
    margin-right: -2rem;
  `}

  ${media.tinyOnly`
    padding: 6rem 4rem;
  `}

  ${media.desktopAndUp`
    padding: 10rem 8rem;
  `};
`;

const CardHeading = styled(H8)`
  /* padding: 2em 2em 0; */
`;

const CardText = styled(P4)`
  color: #000000;
  p {
    margin-bottom: 1.2em;
  }
  p:first-child {
    margin-top: 0;
  }

  ${media.tabletLandscapeAndUp`
    max-width: 15em;
  `};
`;

const BradyProfileImage = styled.div`
  width: 100%;
  height: 50vw;
  max-width: 30rem;
  max-height: 25rem;
  margin: 0 auto;
  margin-top: 4rem;
  position: relative;

  > img {
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: auto;
  }

  ${media.tabletLandscapeAndUp`
    width: 50%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    bottom: 0;
    right: 0;
    position: absolute;
    overflow: hidden;

    > img {
      top: unset;
      bottom: -3%;
      right: -10%;
    }
  `};
`;



// WEBPACK FOOTER //
// ./src/routes/Home/components/SectionHeyThere.js